// extracted by mini-css-extract-plugin
module.exports = {"videoEmbed":"_2aZ09","player":"_70zql","thumbnail":"IXk3E","overlay":"TSlbs","button":"_3ru_L","arrow":"_2lD17","icon":"_2oMN-"};